import { AddButton } from './AddButton'
import useWidgetList from './WidgetList'

import './styles.scss'

type ParentMenu = {
  id: number;
  label: string;
  new: boolean;
};

type SubItemMenu = {
  id: number;
  label: string;
  new: boolean;
};

type AppProps = {
  menuItems: {
    id: number;
    label: string;
    new: boolean;
  }[];
  newParentName: string;
  setSubMenuName: React.Dispatch<React.SetStateAction<SubItemMenu | string | null>>;
  setNewSubItemMenuName: (v: string) => void;
  setStep: (v: number) => void;
};

const App: React.FC<AppProps> = ({ menuItems, newParentName, setSubMenuName, setNewSubItemMenuName, setStep}) => {
  const widgetList = useWidgetList()

  return (
    <div
      style={{
        width: "100%",
        margin: "0 auto",
        position: "relative",
      }}
    >
      <AddButton style={{}} menuItems={menuItems} newParentName={newParentName} setSubMenuName={setSubMenuName} setNewSubItemMenuName={setNewSubItemMenuName} setStep={setStep} />
      {widgetList.el}
    </div>
  );
};

export default App;
